import { DataFormat } from './DataFormat';
import { DataType } from '../DataType';
import { RecordBase } from '../sets/RecordBase';
import { Place } from '../company/Place';
import { VisitorsRecord } from '../sets/VisitorsRecord';
import { EnterExitHourlyRecord } from '../sets/EnterExitHourlyRecord';

export class FormatCam extends DataFormat {
    public getTypeName(): string {
        return "cam";
    }

    public filterByPlace(dataSets: Record<number, RecordBase[]>, place: string): Record<number, RecordBase[]> {
        return dataSets;
    }

    public processDataSets(dataSets: Record<number, RecordBase[]>, place: Place): Record<number, RecordBase[]> {
        return dataSets;
    }
}
